import React from 'react';
import FormButtonRender, {FormButtonProps} from './FormButtonRender';

export const FormButton=({...props}:FormButtonProps):JSX.Element=>{

	return <FormButtonRender {...props}/>;
};
